// extracted by mini-css-extract-plugin
module.exports = {"preview-img":"CTIL6P_5F2","ant-modal-close-x":"_2Qnd8hqWRu"};